import { useState } from "react";
import { auth, db } from "../config/firebase";
import { EmailAuthProvider, reauthenticateWithCredential, deleteUser, signOut } from "firebase/auth";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { useAuthActions } from "../redux/reduxHook/useAuthActions";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './register.css';
import './auth.css';

export const CorruptedAccount = () => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { logout, setCorrupted } = useAuthActions();

  const handleDelete = async (e) => {
    e.preventDefault();

    const user = auth.currentUser;
    if (!user) {
      enqueueSnackbar("No active user session found.", { variant: "error" });
      return;
    }

    setIsDeleting(true);

    try {
      // Attempt to fully destroy the corrupted Auth account
      if (user) {
        await deleteUser(user);
      }
      
      setCorrupted(false);
      logout();
      navigate("/login", { state: { successMessage: "Account successfully deleted. You can now create a new account." } });
    } catch (error) {
      console.error("Deletion error:", error);
      if (error.code === "auth/requires-recent-login") {
        enqueueSnackbar("For security, you must have logged in recently to delete your account.", { variant: "warning" });
        // Sign them out so they can log back in immediately. Their next login will be a "recent" login.
        try { await signOut(auth); } catch (e) {}
        logout();
        navigate("/login", { state: { loginError: "Session expired before deletion. Please enter your email and password to log in again, then click Delete." } });
      } else {
        enqueueSnackbar("Failed to delete account. Please try again.", { variant: "error" });
      }
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <div className='main auth'>
        <div className='aside'><div></div></div>

        <div className='content has-aside'>
          <div className='log-in-content'>
            <div><div className='logo'></div></div>

            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <h2 style={{ fontSize: '24px', fontWeight: 'bold' }}>Account Error</h2>
              <p style={{ marginTop: '10px', fontSize: '14px', lineHeight: '1.5', opacity: 0.8 }}>
                We're experiencing an issue with your account. Please delete your current account and create a new one to continue using the app. We apologize for the inconvenience.
              </p>
            </div>

            <form className='log-in-form' onSubmit={handleDelete}>
              <div>
                <button type="submit" disabled={isDeleting} style={isDeleting ? { opacity: 0.5 } : {}}>
                  {isDeleting ? "Deleting..." : "Delete Your Account"}
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    </>
  );
};
